import { render, staticRenderFns } from "./PageIndex.vue?vue&type=template&id=949b98ea&"
import script from "./PageIndex.vue?vue&type=script&lang=js&"
export * from "./PageIndex.vue?vue&type=script&lang=js&"
import style0 from "./PageIndex.vue?vue&type=style&index=0&id=949b98ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports